import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, TextField, Button, Grid, Box, Typography } from '@mui/material';
import { Login as ApiLogin } from '../../../api';
import { validate } from 'validate.js';
import constraints from '../validate-email-constraints';

const Login = ({ setAuthenticated }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitError, setSubmitError] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitError(false);
    const emailAddress = email.toLowerCase().trim();
    const validation = validate({ emailAddress }, constraints);
    if (validation) return setSubmitError(validation.emailAddress);
    ApiLogin(emailAddress, password)
      .then(() => setAuthenticated(true))
      .catch(e => setSubmitError(e.response?.data?.errors || e.message));
  };

  return (
    <Container>
      <Typography component="h1" variant="h4">Login</Typography>
      {submitError && <Typography component="p" color="error">{submitError}</Typography>}
      <form onSubmit={handleSubmit}>
        <TextField sx={{ marginTop: 1 }} value={email} name="email" fullWidth required label="Email address" onChange={e => setEmail(e.target.value)} />
        <TextField sx={{ marginTop: 1 }} value={password} name="password" type="password" fullWidth required label="Password" autoComplete="false" onChange={e => setPassword(e.target.value)} />
        <Grid container justifyContent="center">
          <Box mt={5} mb={5}>
            <Button variant="contained" color="primary" type="submit">Log in</Button>
          </Box>
        </Grid>
        <Grid container direction="column" alignItems="center">
          <Typography><Link to="/forgot-password" style={{ color: 'inherit' }}>Forgot password?</Link></Typography>
        </Grid>
      </form>
    </Container>
  );
};

export default Login;
